import React, { forwardRef } from "react";

import TrainingCourseImg from "../../../assets/used-images/defaultImg.jpeg";
import IvoryPrint from "../../../assets/used-images/IvoryPrint.png";
import IvoryPrintSperator from "../../../assets/used-images/IvoryPrintSperator.png";
import CertificateOne from "../../../assets/used-images/certificateprint1.jpg";
import CertificateTwo from "../../../assets/used-images/certificateprint2.jpg";
import IvoryList from "../../../assets/used-images/IvoryPrintList.png";
import IvoryPrintEnd from "../../../assets/used-images/IvoryPrintEnd.jpg";
import IvoryPrintBeforeEnd from "../../../assets/used-images/IvoryPrintBeforeEnd.jpg";
import { useTranslation } from "react-i18next";


const PDF = forwardRef(({ course, priceId, selectedPayment }, ref) => {
    const { t } = useTranslation();
    const retrunCleanDesc = (htmlString) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');

        const images = doc.querySelectorAll('img');
        images.forEach(img => img.remove());

        return doc.body.textContent || '';
    };
    const retrunCleanText = retrunCleanDesc(course?.description);

    return (
        <div ref={ref}>
            {/* course title & image */}
            <div className="px-[2em] relative">
                {/* title */}
                <div className="w-[92dvw] py-[2em] relative z-[9] bg-white flex justify-center items-center">
                    <img src={IvoryPrint} alt="image-first-page" className="w-[50dvw]" />
                </div>
                <div>
                    <h1 className="text-[40pt] text-center mb-[3cm] mt-[2cm] font-bold text-primary-tw"
                     style={{ lineHeight: '1.2' }}>
                        {course?.title}
                    </h1>
                </div>

                {/* image */}
                <div>
                    <img src={course?.image || TrainingCourseImg} alt="ivory-course-image" className="rounded-[12px] h-[40dvh] w-[92dvw]" />
                </div>
            </div>

            {/* course details */}
            <div className="relative px-[2em] mt-[10em] content">
                {/* default image in every page header */}
                <img src={IvoryPrintSperator} alt="ivory-logo" className="print-image" />

                {/* التفاصيل */}
                <div className="bg-primary-tw p-[2em] rounded-tl-[40px] rounded-br-[40px]">
                    <h1 className="text-white text-[25pt] mb-[0.7em] text-left">
                        {t('pdf.details')}
                    </h1>
                    <article className="text-white text-[18pt]" style={{ textAlign: 'center' }}>
                        {retrunCleanText}
                    </article>
                </div>

                {/* الاهداف */}
                <div className="mb-[2em] mt-[8em] content">
                    <h2 className="text-primary-tw text-[25pt] font-semibold text-left">
                        {t('pdf.goals')}
                    </h2>
                    <p className="text-primary-tw text-[16pt] text-left">
                        {t('pdf.goals-p')}
                    </p>
                    <ul className="two-column list-disc px-[0.5cm]">
                        {
                            course?.goals?.map((goal, i) => (
                                <li key={goal?.id || i} className="text-left list-disc">
                                    {goal?.title}
                                </li>
                            ))
                        }
                    </ul>
                </div>

                {/* الفئات المستهدفة */}
                <div>
                    <h2 className="text-primary-tw text-[25pt] font-semibold text-left">
                        {t('training-courses.target')}
                    </h2>
                    <ul className="two-column list-disc !px-[0.5cm]">
                        {
                            course?.targets?.map((target, i) => (
                                <li key={target?.id || i} className="list-disc text-left">
                                    {target?.title}
                                </li>
                            ))
                        }
                    </ul>
                </div>


                {/* تفاصيل الانعقاد */}
                <div className="mb-[2em] mt-[5em] content">
                    <div className="flex items-center gap-[0.6em]">
                        <span>
                            <img src={IvoryList} alt="ivory-list" className="w-[1.5em] mb-[0.5em]" />
                        </span>
                        <h2 className="text-primary-tw text-[19pt] font-semibold text-left mb-[0.3em]">
                            {t('pdf.details-2')}
                        </h2>
                    </div>
                    <div>
                        <div className="flex items-start gap-[0.5em] text-left my-[0.1cm]">
                            <span className="text-wrap text-[16pt] text-primary-tw">
                                {t('pdf.course-duration')}:
                            </span>
                            <span className="text-wrap text-[16pt]">
                                {t('pdf.duration-details')}
                            </span>
                        </div>
                        <div className="flex items-start gap-[0.5em] text-left my-[0.1cm]">
                            <span className="text-nowrap text-[16pt] text-primary-tw">
                                {t('pdf.practical')} :
                            </span>
                            <span className="text-wrap text-[16pt]">
                                {t('pdf.practical-time')}
                            </span>
                        </div>
                    </div>
                </div>

                {/* الشهادات */}
                <div>
                    <h2 className="text-primary-tw text-[25pt] font-semibold text-left mt-[0.4em] mb-[0.5em]">
                        {t('training-courses.certificates')}
                    </h2>
                    <div className="py-[0.4cm] px-[1cm] mt-[0.5em] mx-[0.2em] border-[0.5px] border-[#d4ad89] rounded-[8px] flex justify-center items-center">
                        <img src={CertificateOne} alt="cert-one" className=" w-[98dvw] rounded-[12px]" />
                    </div>
                    <div className="py-[0.4cm] px-[1cm] mt-[0.5em] mx-[0.2em] border-[0.5px] border-[#d4ad89] rounded-[8px] flex justify-center items-center">
                        <img src={CertificateTwo} alt="cert-two" className=" w-[98dvw] rounded-[12px]" />
                    </div>
                    {
                        course?.certificate?.map((certificate, i) => (
                            <div className="py-[0.4cm] px-[1cm] mt-[0.5em] mx-[0.2em] border-[0.5px] border-[#d4ad89] rounded-[8px] flex justify-center items-center" key={i}>
                                <img src={certificate?.image} alt="cert-three" className=" w-[98dvw] rounded-[12px]" />
                            </div>
                        ))
                    }
                </div>

                {/* محاور البرنامج */}
                <div className="content">
                    <h2 className="text-primary-tw text-[16pt] font-semibold text-center mb-[0.5em]">
                        {t('pdf.content')}
                    </h2>
                    <div className="two-column">
                        {
                            course?.trainingProgram?.map((item) => (
                                <div key={item?.id} className="text-left">
                                    <div className="flex items-center gap-[0.6em] mx-[2em]">
                                        <span>
                                            <img src={IvoryList} alt="ivory-list" className="w-[1.5em] mb-[0.5em]" />
                                        </span>
                                        <h2 className="text-primary-tw text-[14pt] font-semibold text-left mb-[0.3em]">
                                            {item?.title}
                                        </h2>
                                    </div>
                                    <ul className="list-disc">
                                        {
                                            item?.countent?.map((dataOfItem, ix) => (
                                                <li key={ix} className="text-left mx-[3em] list-disc">
                                                    {dataOfItem?.title}
                                                </li>
                                            ))
                                        }
                                    </ul>
                                </div>
                            ))
                        }
                    </div>
                </div>

            </div>

            {/* before last page */}
            <div className="same-page bg-[#fefefe]">
                <img src={IvoryPrintBeforeEnd} alt="before-end-page" className="h-[100vh] w-[100vw] same-page" />
            </div>

            {/* last page */}
            <div className="same-page">
                <img src={IvoryPrintEnd} alt="end-page" className="h-[100vh] w-[100vw] same-page relative z-[5]" />
            </div>
        </div>
    )
});

export default PDF;